import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { blogPosts } from '../data/mockData';

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-purple-50 to-pink-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Stories of Hope & Recovery
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Real thoughts, honest reflections, and messages of hope for anyone on the recovery journey.
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {blogPosts.map((post, index) => (
              <Card
                key={post.id}
                className="border-2 border-gray-200 hover:border-teal-400 transition-all duration-300 hover:shadow-xl"
              >
                <CardContent className="p-8">
                  <div className="flex flex-col md:flex-row gap-6">
                    {/* Post number badge */}
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
                        <span className="text-2xl font-bold text-teal-700">
                          {String(index + 1).padStart(2, '0')}
                        </span>
                      </div>
                    </div>

                    {/* Post content */}
                    <div className="flex-grow">
                      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                        {post.title}
                      </h2>
                      <p className="text-lg text-gray-600 mb-4 leading-relaxed">
                        {post.excerpt}
                      </p>
                      <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500 mb-4">
                        <div className="flex items-center">
                          <Clock className="w-4 h-4 mr-2" />
                          <span>{post.date}</span>
                        </div>
                        <span>•</span>
                        <span>By {post.author}</span>
                      </div>
                      <Button
                        variant="ghost"
                        className="text-teal-600 hover:text-teal-700 hover:bg-teal-50 p-0 h-auto font-semibold"
                      >
                        Read More
                        <ArrowRight className="ml-2 w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Coming Soon Message */}
          <Card className="border-2 border-dashed border-gray-300 mt-12">
            <CardContent className="p-12 text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                More Stories Coming Soon
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                We're working on sharing more stories, reflections, and resources. 
                Follow us on Facebook to stay updated.
              </p>
              <a
                href="https://www.facebook.com/twosandwichesandanap"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className="bg-teal-600 hover:bg-teal-700 text-white">
                  Follow on Facebook
                </Button>
              </a>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Share Your Story CTA */}
      <section className="py-20 bg-gradient-to-br from-teal-50 to-cyan-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Have a Story to Share?
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Your story of recovery could inspire someone else to take that first step. 
            If you'd like to share your journey, we'd love to hear from you.
          </p>
          <a href="mailto:twosandwichesandanap@hotmail.com?subject=Story Submission">
            <Button size="lg" className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 text-lg">
              Share Your Story
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
